import { languageGlobal } from "./GlobalVariableConfig";

export const getManifestMobile = () => {
    return {
        bundles: [
            {
                name: 'intro-screen',
                assets: [
                    {
                        alias: 'volatilityBase',
                        src: 'assets/mobile/intro/vol_base.webp',
                    },
                    {
                        alias: 'volatilityOn',
                        src: 'assets/mobile/intro/coin_on.webp',
                    },
                    {
                        alias: 'volatilityOff',
                        src: 'assets/mobile/intro/coin_off.webp',
                    },
                    {
                        alias: 'textBase1',
                        src: 'assets/mobile/intro/text_base_1.webp',
                    },
                    {
                        alias: 'textBase2',
                        src: 'assets/mobile/intro/text_base_2.webp',
                    },
                    {
                        alias: 'textBase3',
                        src: 'assets/mobile/intro/text_base_3.webp',
                    },
                    {
                        alias: 'image1',
                        src: 'assets/mobile/intro/image_1.webp',
                    },
                    {
                        alias: 'image2',
                        src: 'assets/mobile/intro/image_2.webp',
                    },
                    {
                        alias: 'image3',
                        src: 'assets/mobile/intro/image_3.webp',
                    },
                    // {
                    //     alias: 'continueBase',
                    //     src: './intro/click_base.webp',
                    // },
                    // {
                    //     alias: 'introAppearSound',
                    //     src: 'assets/mobile/sound/gameloading/Intro_appear.mp3',
                    // },
                ]
            },
            {
                name: 'big-win',
                assets: [
                    {
                        alias: 'bigWinSkel',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/bigwin/es/win_celebration_spanish.skel' : 'assets/mobile/bigwin/win_celebration.skel',
                    },
                    {
                        alias: 'bigWinAtlas',
                        src: languageGlobal === 'es-es' ? 'assets/mobile/bigwin/es/win_celebration_spanish.atlas' : 'assets/mobile/bigwin/win_celebration.atlas',
                    },
                    // {
                    //     alias: 'amount_base',
                    //     src: 'assets/mobile/bigwin/win_amount_base.webp',
                    // },
                ]
            },
            {
                name: 'game-screen',
                assets: [
                    {
                        alias: 'background',
                        src: 'assets/mobile/base/basegame.webp',
                    },
                    {
                        alias: 'backgroundFree',
                        src: 'assets/mobile/base/freegame.webp',
                    },
                    // reels back
                    {
                        alias: 'reelBackSkel',
                        src: 'assets/mobile/base/reel/reel.skel',
                    },
                    {
                        alias: 'reelBackAtlas',
                        src: 'assets/mobile/base/reel/reel.atlas',
                    },
                    //  waterfall on reels intro
                    {
                        alias: 'reelWaterfallSkel',
                        src: 'assets/mobile/base/waterfall/waterfall.skel',
                    },
                    {
                        alias: 'reelWaterfallAtlas',
                        src: 'assets/mobile/base/waterfall/waterfall.atlas',
                    },
                    // Slides in reel back
                    {
                        alias: 'reelBackSliderSkel',
                        src: 'assets/mobile/base/slider/slider.skel',
                    },
                    {
                        alias: 'reelBackSliderAtlas',
                        src: 'assets/mobile/base/slider/slider.atlas',
                    },
                    // win collection meter
                    {
                        alias: 'meterSkel',
                        src: 'assets/mobile/base/meter/meter.skel',
                    },
                    {
                        alias: 'meterAtlas',
                        src: 'assets/mobile/base/meter/meter.atlas',
                    },
                    //win multiplier base 
                    {
                        alias: 'multiplier_base',
                        src: 'assets/mobile/base/win_muliplier/multiplier_base.webp',
                    },
                    //win multiplierFx 
                    {
                        alias: 'multFxSkel',
                        src: 'assets/mobile/base/win_muliplier/multiplier_fx/multiplier_fx.skel',
                    },
                    {
                        alias: 'multFxAtlas',
                        src: 'assets/mobile/base/win_muliplier/multiplier_fx/multiplier_fx.atlas',
                    },
                    //win multiplier font
                    {
                        alias: 'sugar_multiplier',
                        src: 'assets/mobile/base/win_muliplier/multiplier_font/sugar_multiplier.xml',
                    },
                    //logo *********************
                    {
                        alias: 'logoStatic',
                        src: 'assets/mobile/base/logo.webp',
                    },
                    // //logo animation *********************
                    {
                        alias: 'logoSkel',
                        src: 'assets/mobile/base/logo/logo.skel',
                    },
                    {
                        alias: 'logoAtlas',
                        src: 'assets/mobile/base/logo/logo.atlas',
                    },
                    //banner *********************
                    // {
                    //     alias: 'banner',
                    //     src: 'assets/mobile/banner/intro_outro_base.webp',
                    // },
                    //banner-spine
                    {
                        alias: 'bannerSkel',
                        src: 'assets/mobile/banner/outro.skel',
                    },
                    {
                        alias: 'bannerAtlas',
                        src: 'assets/mobile/banner/outro.atlas',
                    },
                    //base game background animation
                    {
                        alias: 'baseBackgroundSkel',
                        src: 'assets/mobile/base/baseBgAnimation/basegame.skel',
                    },
                    {
                        alias: 'baseBackgroundAtlas',
                        src: 'assets/mobile/base/baseBgAnimation/basegame.atlas',
                    },
                    //free game background animation
                    {
                        alias: 'freeBackgroundSkel',
                        src: 'assets/mobile/base/freeBgAnimation/freegame.skel',
                    },
                    {
                        alias: 'freeBackgroundAtlas',
                        src: 'assets/mobile/base/freeBgAnimation/freegame.atlas',
                    },
                    //symbols *********************
                    //hv1
                    {
                        alias: 'hv1Skel',
                        src: 'assets/mobile/symbols/hv1/hv1.skel',
                    },
                    {
                        alias: 'hv1Atlas',
                        src: 'assets/mobile/symbols/hv1/hv1.atlas',
                    },
                    //hv2
                    {
                        alias: 'hv2Skel',
                        src: 'assets/mobile/symbols/hv2/hv2.skel',
                    },
                    {
                        alias: 'hv2Atlas',
                        src: 'assets/mobile/symbols/hv2/hv2.atlas',
                    },
                    //hv3
                    {
                        alias: 'hv3Skel',
                        src: 'assets/mobile/symbols/hv3/hv3.skel',
                    },
                    {
                        alias: 'hv3Atlas',
                        src: 'assets/mobile/symbols/hv3/hv3.atlas',
                    },
                    //hv4
                    {
                        alias: 'hv4Skel',
                        src: 'assets/mobile/symbols/hv4/hv4.skel',
                    },
                    {
                        alias: 'hv4Atlas',
                        src: 'assets/mobile/symbols/hv4/hv4.atlas',
                    },
                    //lv1
                    {
                        alias: 'lv1Skel',
                        src: 'assets/mobile/symbols/lv1/lv1.skel',
                    },
                    {
                        alias: 'lv1Atlas',
                        src: 'assets/mobile/symbols/lv1/lv1.atlas',
                    },
                    //lv2
                    {
                        alias: 'lv2Skel',
                        src: 'assets/mobile/symbols/lv2/lv2.skel',
                    },
                    {
                        alias: 'lv2Atlas',
                        src: 'assets/mobile/symbols/lv2/lv2.atlas',
                    },
                    //lv3
                    {
                        alias: 'lv3Skel',
                        src: 'assets/mobile/symbols/lv3/lv3.skel',
                    },
                    {
                        alias: 'lv3Atlas',
                        src: 'assets/mobile/symbols/lv3/lv3.atlas',
                    },
                    //lv4
                    {
                        alias: 'lv4Skel',
                        src: 'assets/mobile/symbols/lv4/lv4.skel',
                    },
                    {
                        alias: 'lv4Atlas',
                        src: 'assets/mobile/symbols/lv4/lv4.atlas',
                    },
                    //scatter
                    {
                        alias: 'scatterSkel',
                        src: 'assets/mobile/symbols/scatter/scatter.skel',
                    },
                    {
                        alias: 'scatterAtlas',
                        src: 'assets/mobile/symbols/scatter/scatter.atlas',
                    },
                    //wild
                    {
                        alias: 'wildSkel',
                        src: 'assets/mobile/symbols/wild/wild.skel',
                    },
                    {
                        alias: 'wildAtlas',
                        src: 'assets/mobile/symbols/wild/wild.atlas',
                    },
                    //special symbol - golden fist
                    {
                        alias: 'special_symbolSkel',
                        src: 'assets/mobile/symbols/special_symbol/special_symbol.skel',
                    },
                    {
                        alias: 'special_symbolAtlas',
                        src: 'assets/mobile/symbols/special_symbol/special_symbol.atlas',
                    },
                    //giant wild
                    {
                        alias: 'giantWildSkel',
                        src: 'assets/mobile/symbols/giant_wild/giant_wild.skel',
                    },
                    {
                        alias: 'giantWildAtlas',
                        src: 'assets/mobile/symbols/giant_wild/giant_wild.atlas',
                    },
                    // anticipation animation
                    {
                        alias: 'anticipationSkel',
                        src: 'assets/mobile/symbols/wild/wild.skel',
                    },
                    {
                        alias: 'anticipationAtlas',
                        src: 'assets/mobile/symbols/wild/wild.atlas',
                    },
                    //sugar park ttf- font 
                    {
                        alias: 'FREEZONE',
                        src: 'assets/mobile/font/suger_motley_forces/Motley_Forces.ttf',
                    },
                    //sugar win- font 
                    {
                        alias: 'sugar_win_amount',
                        src: 'assets/mobile/font/sugar_win_amount/sugar_win_amount.xml',
                    },

                    /*********** below are 8-bit fonts* */
                    //multiplier- font
                    // {
                    //     alias: 'mult_font_yellow',
                    //     src: 'assets/mobile/font/8-bit_quest_multiplier_yellow/8-bit_quest_multiplier_yellow.xml',
                    // },
                    // {
                    //     alias: 'mult_font_blue',
                    //     src: 'assets/mobile/font/8-bit_quest_multiplier_blue/8-bit_quest_multiplier_blue.xml',
                    // },
                    // xml font for number on intro-outro banner -  // UpheavalTT-BRK-Banner
                    // {
                    //     alias: '8-bit_quest_intro_amount',
                    //     src: 'assets/mobile/font/8-bit_quest_intro_amount/8-bit_quest_intro_amount.xml',
                    // },
                    // xml font for number on intro-outro banner & tickets heading
                    // {
                    //     alias: '8-bit_quest_intro_1',
                    //     src: 'assets/mobile/font/8-bit_quest_intro_1/8-bit_quest_intro_1.xml',
                    // },
                    // xml font for number on intro-outro banner & tickets desciption
                    // {
                    //     alias: '8-bit_quest_intro_2',
                    //     src: 'assets/mobile/font/8-bit_quest_intro_2/8-bit_quest_intro_2.xml',
                    // },

                    // xml font for number for win amount
                    // {
                    //     alias: '8-bit_quest_win_amount',
                    //     src: 'assets/mobile/font/8-bit_quest_win_amount/8-bit_quest_win_amount.xml',
                    // },
                    // xml font for number on Wild-symbol
                    // {
                    //     alias: '8-bit_quest_wild_no',
                    //     src: 'assets/mobile/font/8-bit_quest_wild_no/8-bit_quest_wild_no.xml',
                    // },
                    // {
                    //     alias: 'upheavtt',
                    //     src: 'assets/mobile/font/upheavtt/upheavtt.ttf',
                    // },
                    // {
                    //     alias: 'nokiafc22',
                    //     src: 'assets/mobile/font/nokiafc22/nokiafc22.ttf',
                    // },
                    // {
                    //     alias: 'PressStart2P-Regular',
                    //     src: 'assets/mobile/font/PressStart2P-Regular/PressStart2P-Regular.ttf',
                    // },
                ],
            },
            {
                name: 'sound',
                assets: [
                    {
                        alias: 'bet-level',
                        src: 'assets/mobile/sound/ui/betlevel.mp3',
                    },
                    {
                        alias: 'click',
                        src: 'assets/mobile/sound/ui/click.mp3',
                    },
                    {
                        alias: 'base_music_ambient',
                        // src: 'assets/mobile/sound/flf_mx_basegame.mp3',
                        src: 'assets/mobile/sound/base/Bg_ambient.mp3',
                    },
                    {
                        alias: 'base_music_loop',
                        src: 'assets/mobile/sound/base/Bg_Loop.mp3',
                    },
                    {
                        alias: 'Meter_Appear',
                        src: 'assets/mobile/sound/gameloading/Meter_Appear.mp3',
                    },
                    {
                        alias: 'Screen_Falling',
                        src: 'assets/mobile/sound/gameloading/Screen_Falling.mp3',
                    },
                    {
                        alias: 'Water_Fall',
                        src: 'assets/mobile/sound/gameloading/Water_Fall.mp3',
                    },
                    // {
                    //     alias: 'Intro_appear',
                    //     src: 'assets/mobile/sound/base/Intro_appear.mp3',
                    // },
                    {
                        alias: 'free_background_loop',
                        src: 'assets/mobile/sound/freegame/Fg_Loop.mp3',
                    },
                    {
                        alias: 'Scatter_Trigger',
                        src: 'assets/mobile/sound/freegame/Scatter_Trigger.mp3',
                    },
                    {
                        alias: 'Free_Game_Banner_Appear',
                        src: 'assets/mobile/sound/freegame/Free_Game_Banner_Appear.mp3',
                    },
                    {
                        alias: 'Free_Game_Banner_Disppear',
                        src: 'assets/mobile/sound/freegame/Free_Game_Banner_Disppear.mp3',
                    },
                    // {
                    //     alias: 'freegame_banner_outro',
                    //     src: 'assets/mobile/sound/freegame/8bq_sx_free_game_outro.wav',

                    // },
                    // {
                    //     alias: 'scatter_trigger',
                    //     src: 'assets/mobile/sound/freegame/8bq_mx_intro_appear.mp3',

                    // },
                    {
                        alias: 'reel_stop',
                        src: 'assets/mobile/sound/spin/Reel_Stop.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Landing',
                        src: 'assets/mobile/sound/spin/Special_Symbol_Landing.mp3',
                    },
                    {
                        alias: 'Multiplier_Update',
                        src: 'assets/mobile/sound/spin/Multiplier_Update.mp3',
                    },
                    {
                        alias: 'Meter_Section_Fills',
                        src: 'assets/mobile/sound/spin/Meter_Section_Fills.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Provides_Additional_Wilds',
                        src: 'assets/mobile/sound/spin/Special_Symbol_Provides_Additional_Wilds.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Activates',
                        src: 'assets/mobile/sound/spin/Special_Symbol_Animation_Activates.mp3',
                    },
                    {
                        alias: 'Special_Symbol_Provides_Additional_Multiplier',
                        src: 'assets/mobile/sound/spin/Special_Symbol_Provides_Additional_Multiplier.mp3',
                    },
                    {
                        alias: 'Meter_Gets_Full',
                        src: 'assets/mobile/sound/spin/Meter_Gets_Full.mp3',
                    },
                    {
                        alias: 'Giant_Wild',
                        src: 'assets/mobile/sound/spin/Giant_Wild.mp3',
                    },
                    {
                        alias: 'symbol_win',
                        src: 'assets/mobile/sound/win/Win_Without_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_win_multiply',
                        src: 'assets/mobile/sound/win/Win_With_Multiplier.mp3',
                    },
                    {
                        alias: 'symbol_cascade',
                        src: 'assets/mobile/sound/win/Symbol_Blast.mp3',
                    },
                    {
                        alias: 'win_loop',
                        src: 'assets/mobile/sound/bigwin/Win_Loop.mp3',
                    },
                    {
                        alias: 'Win_Tear_Impact',
                        src: 'assets/mobile/sound/bigwin/Win_Tear_Impact.mp3',
                    },
                    {
                        alias: 'win_tickup',
                        src: 'assets/mobile/sound/bigwin/Win_Count_up.mp3',
                    },
                    {
                        alias: 'win_tickup_end',
                        src: 'assets/mobile/sound/bigwin/Win_Count_Up_End.mp3',
                    },
                ],
            },

        ],
    }
};

